import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MgState } from '@types';
import { useNavigate } from 'react-router-dom';
import { registeredRouteSelector } from '@selectors/app/registeredRouteSelector';
import { Paths } from '@constants/paths';

const AuthRoute = ({ children }) => {
  const isLoggedIn = useSelector<MgState, boolean>(({ auth }) => auth.isLoggedIn);
  const registeredRoute = useSelector(registeredRouteSelector);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      if (registeredRoute) {
        navigate(registeredRoute);
      } else {
        navigate(Paths.NOT_FOUND);
      }

      return;
    }
  }, [isLoggedIn]);

  return <>{!isLoggedIn ? children : ''}</>;
};

export { AuthRoute };
